import { render, staticRenderFns } from "./ModalNotifyMatching.vue?vue&type=template&id=69246813&scoped=true"
import script from "./ModalNotifyMatching.vue?vue&type=script&lang=js"
export * from "./ModalNotifyMatching.vue?vue&type=script&lang=js"
import style0 from "./ModalNotifyMatching.vue?vue&type=style&index=0&id=69246813&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69246813",
  null
  
)

export default component.exports